import {
  UseAdminInvoiceReportSummaryResult,
  useAdminInvoiceReportSummary,
} from '@/context/services/admin_invoice_reports/AdminInvoiceReportSummary.service';

export const useAdminInvoiceReportSummaryData = (
  reportId: string
): UseAdminInvoiceReportSummaryResult => useAdminInvoiceReportSummary(reportId);
